import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackPersonCreated.meta';

export type UseTrackPersonCreatedParams = {
  person_id: string;
  name: string;
  location:
    | 'image-preview'
    | 'people-tab'
    | 'unnamed-people-page'
    | 'named-people-page'
    | 'person-page-header'
    | 'person-page-menu'
    | 'people-settings';
};

export const useTrackPersonCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackPersonCreated = useCallback(
    (params: UseTrackPersonCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPersonCreated };
};
